// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qaIa5","iconContainer":"styles_iconContainer__as6A4","icon":"styles_icon__B8VZl"};